/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cc_PickerInputs */

const en_cc_picker = /** @type {(inputs: Cc_PickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a meeting for Calendar`)
};

const id_cc_picker = /** @type {(inputs: Cc_PickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih meeting untuk Calendar`)
};

/**
* | output |
* | --- |
* | "Choose a meeting for Calendar" |
*
* @param {Cc_PickerInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cc_picker = /** @type {((inputs?: Cc_PickerInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cc_PickerInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cc_picker(inputs)
	return en_cc_picker(inputs)
});